export default __webpack_public_path__ + "static/media/Banner2022_Consultant-min.fd5433cd.png";